import apiClient from "./apiClient";

export const checkUserExistence = async (
  loginInput: string,
  userType: string
) => {
  const isMobile = /^[0-9]{10}$/.test(loginInput);
  const Role = userType === "merchant" ? "Merchants" : "Hosts";
  const queryPayload = isMobile
    ? {
        filterParams: {
          IndexName: "mobileNumber-countryCode-index",
          KeyConditionExpression:
            "mobileNumber = :mobileNumber and countryCode = :countryCode",
          ExpressionAttributeValues: {
            ":mobileNumber": loginInput,
            ":countryCode": "+91",
          },
        },
      }
    : {
        filterParams: {
          IndexName: "emailId-index",
          KeyConditionExpression: "emailId = :emailId",
          ExpressionAttributeValues: {
            ":emailId": loginInput,
          },
        },
      };

  return apiClient.post(`/${Role}/bulk-ops/query`, queryPayload);
};

export const loginUser = async (
  loginInput: string,
  password: string,
  userType: string,
  countryCode?: string
) => {
  const isMobile = /^[0-9]{10}$/.test(loginInput);
  const apiType = userType === "merchant" ? "Merchant" : "Host";
  const apiEndpoint = `/sign-on/${apiType}/via-mobile`;

  const payload = {
    countryCode: isMobile ? countryCode : undefined,
    mobileNumber: isMobile ? loginInput : undefined,
    emailId: !isMobile ? loginInput : undefined,
    password,
    isMobileVerified: isMobile,
  };

  return apiClient.post(apiEndpoint, payload);
};

export const registerUser = async (
  userType: "Merchant" | "Host",
  payload: any
) => {
  try {
    const response = await apiClient.post(
      `/sign-on/${userType}/via-mobile`,
      payload
    );
    return response;
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
};

export const forgotPassword = async (userType: string, payload: any) => {
  try {
    const response = await apiClient.post(
      `/forgot-password/${userType}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
};

export const updatePassword = async (
  userType: string,
  userId: any,
  payload: any
) => {
  try {
    const response = await apiClient.put(`${userType}/id/${userId}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
};
